export const SLEAP_UI_TOKEN_KEY = "WL_UI_APP_TOKEN";
export const WALLET_PROVIDER_KEY = "previousWalletProvider";
export const LAST_WALLET_USED_ADDRESS_KEY = "previousUsedWallet";
